// Import polyfills first, with a try-catch to prevent initialization errors
try {
  import('./polyfill.js').catch(e => console.warn('Polyfill load error:', e));
} catch (e) {
  console.warn('Polyfill initialization error:', e);
}

import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { supabase } from "./services/supabase";
import "./style.css";
import "./registerServiceWorker";
import "./assets/global-dialog.css"; // Import global dialog styles

// Quasar
import { Quasar, Dialog, Notify, Loading } from 'quasar';

// Import Quasar css
import 'quasar/dist/quasar.sass';

// Import icon libraries
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/material-icons-round/material-icons-round.css';
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css';

// Import custom plugins
import OfflineHandler from "./plugins/offline-handler";

import { createUnhead } from '@unhead/vue';

// Create the app
const app = createApp(App);

// Register Unhead for SEO meta management
const head = createUnhead();
app.use(head);

// Set default meta tags via head.push() (not useHead, which requires component context)
head.push({
  title: 'CouponLa - Best Coupons & Deals in India',
  meta: [
    { name: 'description', content: 'Find the latest coupons, promo codes, and deals for top Indian stores. Save more on every purchase with CouponLa.' },
    { name: 'keywords', content: 'coupons, deals, promo codes, India, discounts, shopping, offers, CouponLa' },
    { property: 'og:title', content: 'CouponLa - Best Coupons & Deals in India' },
    { property: 'og:description', content: 'Discover the best coupons and deals for Indian online shopping. Updated daily!' },
    { property: 'og:type', content: 'website' },
    { property: 'og:site_name', content: 'CouponLa' },
    { property: 'og:locale', content: 'en_IN' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'CouponLa - Best Coupons & Deals in India' },
    { name: 'twitter:description', content: 'Save more with the latest Indian coupons and deals from CouponLa.' }
  ]
});

// Setup Pinia before auth listeners
const pinia = createPinia();
app.use(pinia);

// Use Vue Router
app.use(router);

// Use Quasar
app.use(Quasar, {
  plugins: {
    Dialog,
    Notify,
    Loading
  },
  config: {
    dark: false, // Force light mode to prevent dark theme issues on mobile
    notify: { position: 'top', timeout: 3000 },
    loading: { spinnerColor: 'primary' }
  }
});

// Use custom plugins
app.use(OfflineHandler);

supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_OUT') {
    localStorage.removeItem('user');
  }
});

// Mount the app
app.mount("#app");
